import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CardFilledIcon = props => {
  return (
    <Svg
      width={22}
      height={16}
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.184.666L11 .5 3.816.666A3.057 3.057 0 00.87 3.17a26.718 26.718 0 000 9.66 3.058 3.058 0 002.945 2.504L11 15.5l7.184-.166a3.058 3.058 0 002.945-2.504 26.721 26.721 0 000-9.66A3.058 3.058 0 0018.184.666zM20 7a1 1 0 01-1 1H3a1 1 0 110-2h16a1 1 0 011 1z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default CardFilledIcon;
